import React, { useEffect, useState, useContext } from "react";
import formatCurrency from "../func/currency_formatter";
import { TemplateContext } from "../layout";
import { QuestionMarkIcon } from "../utils/miscIcons";
import TotalSavings from "./orderSummary/TotalSavings";
import Separator from "./Separator";

const OrderTotals = ({ modifications, margin }) => {
  const summary = window.post_template?.checkout_v4_summary;
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [total, setTotal] = useState();
  const [savings, setSavings] = useState();
  const shippingPolicyUrl = summary.checkout_v4_summary_shippingLink;
  const shippingPrice = Number(templateContext.config?.product?.shipping_price).toFixed(2);
  let subtotal =
    (templateContext.discountsEnabled &&
      templateContext.discountCode == window.productData.discount_codes.discount_code) ||
    !templateContext.discountsEnabled
      ? templateContext.config?.product?.price * templateContext.config?.product?.amount
      : templateContext.config?.product?.price * templateContext.config?.product?.amount;

  let warrantyPrice = templateContext.config?.warrantyState
    ? templateContext.config?.product?.warranty_price * templateContext.config?.product?.amount
    : 0.0;

  subtotal = Number(subtotal) + Number(warrantyPrice);
  useEffect(() => {
    let finalSavings = 0;

    templateContext?.config?.product?.fake_products &&
      templateContext.config?.product?.fake_products.map(
        (e) => (finalSavings = Number(finalSavings) + Number(e.price))
      );
    if (
      (templateContext.discountsEnabled &&
        templateContext.discountCode == window.productData.discount_codes.discount_code) ||
      !templateContext.discountsEnabled
    ) {
      finalSavings =
        finalSavings +
        (Number(templateContext.config?.product.old_price) -
          Number(templateContext.config?.product.price * templateContext.config?.product.amount));
    }
    setSavings(finalSavings.toFixed(2));

    const finalPrice = Number(subtotal) + Number(shippingPrice);
    setTotal(finalPrice.toFixed(2));
    setTemplateContext({ ...templateContext, finalPrice: finalPrice });
  }, [subtotal, warrantyPrice]);

  // formatted values

  const formattedSavings = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(savings).toFixed(2))
    : formatCurrency(Number(savings));

  const formattedTotal = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(total).toFixed(2))
    : formatCurrency(Number(total));

  const formattedShippingPrice = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(shippingPrice).toFixed(2))
    : formatCurrency(Number(shippingPrice));

  const formattedSubtotal = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(subtotal).toFixed(2))
    : formatCurrency(Number(subtotal));

  return (
    <div className="orderTotals__container" style={{ margin: margin ?? "" }}>
      {!modifications?.noSummary && (
        <div className="orderTotals">
          <div className="orderTotals__item">
            <p>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_orderLabel}</p>
            <p>{formattedSubtotal}</p>
          </div>
          <div className="orderTotals__item">
            <p className="orderTotals__item__shippingLabel">
              <span style={{ marginRight: "4px" }}>
                {window.post_template.checkout_v4_summary.tr_checkout_v4_summary_shippingLabel}
              </span>{" "}
              <a className="policy-tooltip" href={shippingPolicyUrl}>
                <QuestionMarkIcon />
              </a>
            </p>
            <p>{formattedShippingPrice}</p>
          </div>
        </div>
      )}
      {modifications?.noSummary ? <Separator margin="0px 0px 16px 0px" /> : <Separator />}
      <TotalSavings
        type={templateContext?.totalSavingsStyle}
        label={window.post_template?.checkout_v4_summary?.tr_checkout_v4_summary_savingsLabel}
        savings={formattedSavings}
      />
      <div className="total">
        <div>{window.post_template?.checkout_v4_summary.tr_checkout_v4_summary_totalLabel}</div>
        <div>{formattedTotal}</div>
      </div>
    </div>
  );
};

export default OrderTotals;
